import { ValorCartaCreditoTrimestralVO } from './valor-carta-credito-trimestral-vo.model';
import { EmpresaVO } from './empresa-vo.model'
import { AcumuladoVO } from "./acumulado-vo.model";
import { CartaCreditoFinanceiroGerada } from './carta-credito-financeiro-gerada.model';

export class CartaGeradaTrimestralVO {

  empresa: EmpresaVO;
  cartaGerada: CartaCreditoFinanceiroGerada
  sudanSudene: ValorCartaCreditoTrimestralVO;
  sudanSudeneTecnac: ValorCartaCreditoTrimestralVO;
  demaisRegioes: ValorCartaCreditoTrimestralVO;
  demaisRegioesTecnac: ValorCartaCreditoTrimestralVO;
  total: ValorCartaCreditoTrimestralVO;
  acumulado: AcumuladoVO;
  padis: ValorCartaCreditoTrimestralVO;
  
}
